import { WebChatWidget } from './core/Widget';
import type { WidgetConfig } from './types';
import './styles/widget.css';

(() => {
  const script = document.currentScript as HTMLScriptElement;
  if (!script) return;

  try {
    const url = new URL(script.src);
    const params = url.searchParams;

    const apiKey = params.get('key');
    if (!apiKey) {
      // console.error('WebChat Widget: API key es requerida);
      return;
    }

    const config: WidgetConfig = {
      apiKey: apiKey,                                           // Tu backend API key
      ablyApiKey: params.get('ably') ?? 'WPwNYg.xW3JUA:GoT680_XP3AVHNiSjgMsr57ISiBHlpjhV79X-ex1a_g',             // Ably API key desde parámetro
      position: (params.get('position') as any) || 'bottom-right',
      theme: (params.get('theme') as any) || 'light',
      primaryColor: params.get('color') || undefined,
      serverUrl: params.get('server') || undefined,
      channelPrefix: params.get('channel') || 'webchat',
      title: params.get('title') || undefined
    };

    const initWidget = () => {
      try {
        const widget = new WebChatWidget(config);

        // Exponer widget globalmente
        if (typeof window !== 'undefined') {
          (window as any).webChatWidget = widget;
        }

        // Dispatch evento cuando esté listo
        document.dispatchEvent(new CustomEvent('webChatWidgetReady', {
          detail: { widget, config }
        }));

        console.log('WebChat Widget inicializado correctamente');
      } catch (error) {
        console.error('Error inicializando WebChat Widget:', error);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWidget);
    } else {
      initWidget();
    }

  } catch (error) {
    console.error('Error procesando parámetros del WebChat Widget:', error);
  }
})();

// Exportar para uso manual
export { WebChatWidget };
export type * from './types';

// Interfaz global para TypeScript
declare global {
  interface Window {
    webChatWidget?: WebChatWidget;
  }
}
